export function getStudioLogoUrl(record) {
  if (!record) return null;
  const customize = record?.settings?.customize_v1;
  const candidates = [
    record.image_url,
    record.logo_url,
    record.logoUrl,
    record.avatar_url,
    record.avatarUrl,
    customize?.logoUrl,
    customize?.logo_url,
  ];
  return candidates.find((value) => typeof value === "string" && value.length > 0) || null;
}
